import { Instagram, ExternalLink } from "lucide-react";

/**
 * PromoCard — surface a talent's Instagram promo on the magazine.
 * No IG API required: links out to the public Instagram profile/post.
 */
export default function PromoCard({ handle, url, displayName, tagline }) {
  const cleanHandle = handle.replace(/^@/, "");
  const profileUrl = url || `https://www.instagram.com/${cleanHandle}`;
  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`promo-card-${cleanHandle}`}
      className="group block pfc-card p-6 hover:border-pfc-gold/70 transition relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-pfc-gold/5 via-transparent to-red-500/5 opacity-0 group-hover:opacity-100 transition" />
      <div className="relative">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 via-red-500 to-yellow-400 flex items-center justify-center">
            <Instagram className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="label text-pfc-gold text-[10px]">Talent Promo</div>
            <div className="font-display text-xl text-white uppercase truncate">{displayName || `@${cleanHandle}`}</div>
          </div>
          <ExternalLink className="w-4 h-4 text-white/40 group-hover:text-pfc-gold transition" />
        </div>
        {tagline && (
          <p className="text-white/70 font-body text-sm leading-relaxed mb-4">{tagline}</p>
        )}
        <div className="flex items-center justify-between pt-4 border-t border-white/10">
          <span className="font-sub uppercase tracking-[0.2em] text-[10px] text-white/50">@{cleanHandle}</span>
          <span className="font-sub uppercase tracking-[0.2em] text-[10px] text-pfc-gold group-hover:text-white transition">View Flyer →</span>
        </div>
      </div>
    </a>
  );
}
